// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__hEapC","body":"styles_body__FtlFN","footer":"styles_footer__KvH4-"};